import OnboardingSteps from "../enums/Step";
export default function hasSetDetails(onboarding) {
    var _a;
    return (_a = onboarding === null || onboarding === void 0 ? void 0 : onboarding.completedSteps) === null || _a === void 0 ? void 0 : _a.includes(OnboardingSteps.SET_DETAILS);
}
